// import {KTSVG} from '../../../../../../_metronic/helpers'
import { KTSVG } from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const ContactEditModalHeader = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      {/* <h2 className='fw-bolder'>Add Contact</h2> */}
      <h2 className='fw-bolder '>{itemIdForUpdate ? "Edit" : "Add"}  Contact</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-contacttypes-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {ContactEditModalHeader}
